import { createSelector } from '@reduxjs/toolkit'
import { ApplicationState } from 'redux/Stores/types'

export const selectIntegrations = createSelector(
  [(state: ApplicationState) => state.IntegrationStore.data],
  (data) => data
)

export const selectHasConfigurableIntegrations = createSelector(
  [(state: ApplicationState) => state.IntegrationStore.data],
  (data) => data.length > 0
)

export const selectIntegrationsFetched = createSelector(
  [(state: ApplicationState) => state.IntegrationStore.fetched],
  (fetched) => fetched
)

export const selectFortnoxTenantStatus = createSelector(
  [(state: ApplicationState) => state.IntegrationStore.fortnoxStatus],
  (fortnoxStatus) => fortnoxStatus
)

export const selectFortnoxStatusFetched = createSelector(
  [(state: ApplicationState) => state.IntegrationStore.statusFetched],
  (statusFetched) => statusFetched
)
